import React from 'react'
import { provideState, injectState } from 'freactal'
import app from '../../../feathers'

import { Route, Redirect, Switch } from 'react-router-dom'
import { Grid, Cell } from 'react-mdl'
import FullAreaContent from '../../components/FullAreaContent'
import PresentationSettings from './PresentationSettings'
import SlidesList from './SlidesList'
import SlideContent from './SlideContent'

import { sectionIndexToPath } from '../../../lib'

const withState = provideState({
  initialState: () => ({
    addSlideError: null,
    updateSlideError: null,
    duplicateSlideError: null,
    deleteSlideError: null,
  }),
  effects: {
    addSlide: async (effects, { _id, sectionIndex, slide }) => {
      try {
        const sectionPath = sectionIndexToPath(sectionIndex)
        await app.service('units').patch(_id, {
          $push: {
            [`sections.${sectionPath}.eLearningPresentation.slides`]: slide,
          },
        })
      } catch (addSlideError) {
        return state => ({ ...state, addSlideError })
      }
    },
    initializeSlides: async (effects, { _id, sectionsMap }) => {
      try {
        await app.service('units').patch(_id, sectionsMap)
      } catch (addSlideError) {
        return state => ({ ...state, addSlideError })
      }
    },
    updateSlide: async (
      effects,
      { _id, sectionIndex, slideIndex, slide: { content, image } },
    ) => {
      try {
        const sectionPath = sectionIndexToPath(sectionIndex)
        await app.service('units').patch(_id, {
          [`sections.${sectionPath}.eLearningPresentation.slides.${slideIndex}.content`]: content,
          [`sections.${sectionPath}.eLearningPresentation.slides.${slideIndex}.image`]: image,
        })
      } catch (updateSlideError) {
        return state => ({ ...state, updateSlideError })
      }
    },
    // TODO: Investigate changing update to patch with index.
    // duplicateSlide: async (
    //   effects,
    //   { _id, sectionIndex, slideIndex, slide: { content, image } },
    // ) => {
    //   try {
    //     const sectionPath = sectionIndexToPath(sectionIndex)
    //     const position = parseInt(slideIndex, 10) + 1
    //     await app.service('units').update(_id, {
    //       $push: {
    //         [`sections.${sectionPath}.presentation.slides`]: {
    //           $each: [{ content, image }],
    //           $position: position,
    //         },
    //       },
    //     })
    //   } catch (duplicateSlideError) {
    //     return state => ({ ...state, duplicateSlideError })
    //   }
    // },
    deleteSlide: async (effects, { _id, sectionIndex, slideId }) => {
      try {
        const sectionPath = sectionIndexToPath(sectionIndex)
        await app.service('units').patch(_id, {
          $pull: {
            [`sections.${sectionPath}.eLearningPresentation.slides`]: {
              _id: slideId,
            },
          },
        })
      } catch (deleteSlideError) {
        return state => ({ ...state, deleteSlideError })
      }
    },
  },
})

function ELearningPresentationContent({ match: { params: { unitId } } }) {
  return (
    <Switch>
      <Redirect
        exact
        from={`/units/${unitId}/e-learning-presentation/`}
        to={`/units/${unitId}/e-learning-presentation/0.0/0/`}
      />
      <Route
        strict
        path="/units/:unitId/e-learning-presentation/settings/"
        component={PresentationSettings}
      />
      <Route
        render={() => (
          <FullAreaContent>
            <Grid style={{ height: '100%', boxSizing: 'border-box' }}>
              <Cell col={2}>
                <Route
                  path="/units/:unitId/e-learning-presentation/:sectionIndex?/:slideIndex?/"
                  component={SlidesList}
                />
              </Cell>
              <Cell col={10}>
                <Route
                  exact
                  path="/units/:unitId/e-learning-presentation/:sectionIndex/:slideIndex/"
                  component={SlideContent}
                />
              </Cell>
            </Grid>
          </FullAreaContent>
        )}
      />
    </Switch>
  )
}

export default withState(injectState(ELearningPresentationContent))



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/ELearningPresentationContent/index.js